import { css } from '@emotion/react';
import { DownloadSimple } from '@phosphor-icons/react';
import { useEditAppContext } from 'client/lib/EditApp';
import { useProjectState } from 'client/state/ProjectState';
import { ProjectDomain } from 'client/pages/project/components/ProjectDomain';
import { EditAppSaveButton } from 'client/components/EditApp/EditAppSaveButton';
import { Settings, Section, SectionSkeleton } from 'client/components/Layout/Settings';
import { ComponentsSections } from 'client/sections/components/ComponentsSections';
import { Repository } from 'client/sections/repository/Repository';
import { ProjectActions } from './components/ProjectActions';
import { ProjectGeneral } from './components/ProjectGeneral';

export const ProjectOptionsTab = () => {
  const editAppContext = useEditAppContext();
  const isQuickLaunch = useProjectState((state) => state.document?.repositoryUrl == null);

  const isReady = editAppContext.isReady;

  if (!isReady) {
    return (
      <Settings css={settingsStyle}>
        <SectionSkeleton />
      </Settings>
    );
  }

  return (
    <Settings css={settingsStyle}>
      <Section title="General" subtitle="Basic information about this project.">
        <ProjectGeneral />
      </Section>

      <Section title="Parent Domain" subtitle="Configure the default parent domain for deployments inside this project.">
        <ProjectDomain />
      </Section>

      {/* <ComponentsSections /> */}

      {/* <Section title="Environment" subtitle="Edit environment variables.">
        <ProjectEnvironment />
      </Section> */}

      {!isQuickLaunch && (
        <Section title="Repository" subtitle="The Git repositories this project pulls its code from.">
          <Repository />
        </Section>
      )}

      <Section title="Actions" subtitle="Run one-time actions for this project." css={actionsStyle}>
        <ProjectActions />
      </Section>

      <Section css={footerStyle}>
        <EditAppSaveButton icon={<DownloadSimple weight="regular" />} primary large>
          Save Changes
        </EditAppSaveButton>
      </Section>
    </Settings>
  );
};

const settingsStyle = css`
  margin-top: -4rem;
`;

const actionsStyle = css`
  align-items: center;
`;

const footerStyle = css`
  > div {
    display: flex;
    align-items: center;
    justify-content: right;
  }
`;
